/**
 * Канонические публичные URL legal-страниц markbase.ru (152-ФЗ ст. 18.1).
 * SSOT текстов — UAM; здесь только маршруты витрины.
 */

const DEFAULT_BASE = 'https://markbase.ru';

/** consent_type (UAM) → path на markbase.ru */
export const CONSENT_TYPE_TO_PATH = {
  privacy_policy: '/privacy',
  pd_processing_policy: '/privacy',
  terms_of_service: '/terms',
  personal_data_processing: '/personal-data',
  cookie_consent: '/cookies',
};

export function getLegalPublicBaseUrl() {
  const raw = (
    process.env.REACT_APP_LEGAL_PUBLIC_BASE_URL
    || process.env.REACT_APP_SITE_BASE_URL
    || (typeof window !== 'undefined' ? window.location.origin : '')
    || DEFAULT_BASE
  ).trim();
  if (!raw) return DEFAULT_BASE;
  return raw.replace(/\/+$/, '');
}

export function legalDocumentPath(consentType) {
  const key = String(consentType || '').trim();
  return CONSENT_TYPE_TO_PATH[key] || null;
}

export function legalDocumentUrl(consentType) {
  const path = legalDocumentPath(consentType);
  if (!path) return null;
  return `${getLegalPublicBaseUrl()}${path}`;
}

/** Основные документы для hub-страницы (фиксированный порядок). */
export const LEGAL_HUB_ENTRIES = [
  { consentType: 'privacy_policy', label: 'Политика конфиденциальности', path: '/privacy' },
  { consentType: 'terms_of_service', label: 'Пользовательское соглашение', path: '/terms' },
  { consentType: 'personal_data_processing', label: 'Обработка персональных данных', path: '/personal-data' },
  { consentType: 'cookie_consent', label: 'Файлы cookie', path: '/cookies' },
];
